import { render, staticRenderFns } from "./CommunePartnerCard.vue?vue&type=template&id=31d1ea0a&scoped=true&"
import script from "./CommunePartnerCard.vue?vue&type=script&lang=js&"
export * from "./CommunePartnerCard.vue?vue&type=script&lang=js&"
import style0 from "./CommunePartnerCard.vue?vue&type=style&index=0&id=31d1ea0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d1ea0a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VBtn,VIcon,VSheet})
